export enum ColumnType {
    ENUM,
    DATE,
    TEXT,
    BIG,
    IMAGE,
    LINK
}


// WEBPACK FOOTER //
// ./src/app/ui/list/ColumnType.ts